import {
  BasePopupComponent,
  StartFreeSpinsPopupController,
  StartFreeSpinsPopupView,
} from '@cgs/machines';
import { Container } from '@cgs/wge';
import { CorsicaStartFreeSpinsPopupView } from './corsica-start-free-spins-popup.view';

interface StartFreeSpinsPopupOptions {
  stopBackgroundSoundOnStart: boolean;
  stopBackgroundSoundOnAdd: boolean;
  useFreeSpinMode: boolean;
  useViewUpdater: boolean;
}

export class CorsicaStartFreeSpinsPopupComponent extends BasePopupComponent<StartFreeSpinsPopupView> {
  private view: CorsicaStartFreeSpinsPopupView;

  constructor(container: Container, options?: StartFreeSpinsPopupOptions) {
    super(container, 'slot/popups/start_freespins/scene');

    this.view = new CorsicaStartFreeSpinsPopupView(this.rootScene, this.popupScene);

    this.popupController = new StartFreeSpinsPopupController(
      container,
      this.view as unknown as StartFreeSpinsPopupView,
      options
    );
  }
}
